import { createContext, type ReactNode, useCallback, useContext, useMemo, useState } from 'react';

import type { ExperimentalAppointment } from '../fixtures';

interface DrawerContextValue {
  appointment: ExperimentalAppointment | null;
  openDrawer: (appt: ExperimentalAppointment) => void;
  closeDrawer: () => void;
}

const Ctx = createContext<DrawerContextValue | null>(null);

export const EligibilityDrawerProvider = ({ children }: { children: ReactNode }) => {
  const [appointment, setAppointment] = useState<ExperimentalAppointment | null>(null);

  const openDrawer = useCallback((appt: ExperimentalAppointment) => setAppointment(appt), []);
  const closeDrawer = useCallback(() => setAppointment(null), []);

  const value = useMemo(
    () => ({ appointment, openDrawer, closeDrawer }),
    [appointment, openDrawer, closeDrawer],
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useEligibilityDrawer = (): DrawerContextValue => {
  const ctx = useContext(Ctx);
  if (!ctx) {
    throw new Error('useEligibilityDrawer must be used inside EligibilityDrawerProvider');
  }
  return ctx;
};
